export default class SessionResult {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    tenantID: 'validString',
    courseID: 'validString',
    userID: 'validString',
    sessionID: 'validString',
    resultStatus: 'validString',
    resultNotes: 'optionalValidString',
    resultGrade: 'optionalNumber',
    resultDate: 'validString',
    externalResult: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createSessionResult(sessionID, resultID, externalID, resultObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/result/${resultID}/${externalID}`;
    req.body = resultObj;
    return await req.exec();
  }
  async updateSessionResult(sessionID, resultID, externalID, resultObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/session/' + sessionID + `/result/${resultID}/${externalID}`;
    req.body = resultObj;
    return await req.exec();
  }
  async deleteSessionResult(sessionID, resultID, externalID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/session/' + sessionID + `/result/${resultID}/${externalID}`;
    return await req.exec();
  }
  async getSessionResult(sessionID, resultID, externalID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + `/result/${resultID}/${externalID}`;
    return await req.exec();
  }
  async getSessionResultsBySessionID(sessionID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/results/';
    return await req.exec();
  }
}
